<template>
  <div>
    <Header :showProductTour="false" />
    <div id="timeline-body">
      <h1 class="text-secondary">Product Timelines</h1>
      <MultiSelect
        :options="productOptions"
        placeholder="Add products..."
        :value="selectedProducts"
        @tagChange="onSelectdProductsChange"
      />

      <div id="timeline-embed"></div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import MultiSelect from '@/components/MultiSelect.vue';
import { Timeline } from '@knight-lab/timelinejs';
import '@knight-lab/timelinejs/dist/css/timeline.css';
const data = [
  {
    application_number: '134',
    application_type: 'NDA',
    product: 'abatacept',
    doc_id: '134',
    page_number: 28,
    event_tables: [
      {
        date: '2022-02-01',
        table_cols: ['IND submission', 'submission description'],
        predicted_event: 'Type A',
        date_identified_from: 0,
      },
      {
        date: '2022-03-02',
        table_cols: ['NDA approval', 'approal description'],
        predicted_event: 'IND',
        date_identified_from: 0,
      },
    ],
  },
  {
    application_number: '2',
    application_type: 'NDA',
    product: 'abarelix',
    doc_id: '2',
    page_number: 2,
    event_tables: [
      {
        date: '2022-01-04',
        table_cols: ['IND submission', 'submission description'],
        predicted_event: 'Type A',
        date_identified_from: 0,
      },
      {
        date: '2022-05-19',
        table_cols: ['NDA approval', 'approal description'],
        predicted_event: 'IND',
        date_identified_from: 0,
      },
    ],
  },
];

export default {
  name: 'TimelinesPage',
  components: {
    Header,
    MultiSelect,
  },
  data() {
    return {
      selectedProducts: [],
    };
  },

  watch: {
    selectedProducts() {
      const events = data.reduce((acc, { product, event_tables }) => {
        if (!this.selectedProducts.includes(product)) {
          return acc;
        }
        const event = event_tables.map(({ date, table_cols }) => {
          const splitDate = date.split('-').map(Number);

          return {
            group: product,
            start_date: {
              year: splitDate[0],
              month: splitDate[1],
              day: splitDate[2],
            },
            text: {
              headline: `${product}: ${table_cols[0]}`,
              text: `${table_cols.join(', ')}`,
            },
          };
        });

        return [...acc, ...event];
      }, []);

      window.timeline = new Timeline('timeline-embed', {
        events,
      });
    },
  },
  created() {
    this.productOptions = data.map(({ product }) => product);
  },

  methods: {
    onSelectdProductsChange(value) {
      this.selectedProducts = value;
    },
  },
};
</script>

<style scoped>
#timeline-body {
  margin-top: 130px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: start;
}
#timeline-embed {
  height: 70vh;
}
</style>
